import { useQuery } from '@tanstack/react-query';
import { customFetcher } from './customFetcher';
import {
    DashboardEventMediaItem,
    dashboardEventMediaListSchema,
} from '../dashboard/dashboardEventMediaSchemas';

interface UseDashboardEventMediaParams {
    limit?: number;
    previewLimit?: number;
}

export const dashboardEventMediaQueryKey = (limit: number, previewLimit: number) =>
    ['dashboard-event-media', limit, previewLimit] as const;

export const useDashboardEventMedia = ({
    limit = 20,
    previewLimit = 4,
}: UseDashboardEventMediaParams) => {
    const { data = [], isLoading, isError, error, refetch } = useQuery<DashboardEventMediaItem[], Error>({
        queryKey: dashboardEventMediaQueryKey(limit, previewLimit),
        queryFn: async () => {
            const response = await customFetcher<unknown>({
                endpoint: `/dashboard/event-media/?limit=${limit}&preview_limit=${previewLimit}`,
            });
            return dashboardEventMediaListSchema.parse(response);
        },
        initialData: [],
        refetchOnWindowFocus: false,
    });

    return {
        eventMedia: data,
        isLoadingEventMedia: isLoading,
        isErrorEventMedia: isError,
        eventMediaError: error,
        refetchEventMedia: refetch,
    };
};
